import { EntityActivityUserService } from '@/api/AuthService'

export const actions = {
  LOAD_AUTH_USER_ENTITY_ACTIVITIES ({ state, commit }) {
    if (!state.hasLoadedAuthUserEntityActivities) {
      let params = {
        activities: [state.activities.AUDIOLOGY, state.activities.DISPENSER_FIELD, state.activities.DISPENSER_PREMISES].join(',')
      }

      EntityActivityUserService
        .getOwnEntityActivityUserRecords(params)
        .then(records => commit('SET_AUTH_USER_ENTITY_ACTIVITIES', { records }))
        .catch(() => commit('RESET_AUTH_USER_ENTITY_ACTIVITIES'))
    }
  },

  USER_LOGGED_OUT ({ commit }) {
    commit('RESET_AUTH_USER_ENTITY_ACTIVITIES')
  }
}
